var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9474 6.85876H0V18.6482C0 20.8574 1.79089 22.6482 4 22.6482H14.9474C17.1565 22.6482 18.9474 20.8574 18.9474 18.6482V6.85876ZM4 21.1482C2.61926 21.1482 1.5 20.029 1.5 18.6482V8.35876H17.4474V18.6482C17.4474 20.029 16.3281 21.1482 14.9474 21.1482H4Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3",
    d: "M6.01318 12.06V5.86806C6.01318 3.95686 7.56251 2.40753 9.47371 2.40753C11.3849 2.40753 12.9342 3.95686 12.9342 5.86806V12.06C12.9342 12.4742 13.27 12.81 13.6842 12.81C14.0984 12.81 14.4342 12.4742 14.4342 12.06V5.86806C14.4342 3.12844 12.2133 0.907532 9.47371 0.907532C6.73409 0.907532 4.51318 3.12844 4.51318 5.86806V12.06C4.51318 12.4742 4.84897 12.81 5.26318 12.81C5.6774 12.81 6.01318 12.4742 6.01318 12.06Z",
    fill: "#262626"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.dd0252e2d49c5d51fe2aa09f7023fd16.svg";
export { ForwardRef as ReactComponent };